/**
 * /periods + /periods/devir API adaptörü — Çalışma Dönemi & Devir (Faz 2)
 */
import { apiClient } from '@/services/api.client'

export type DonemDurum = 'Acik' | 'Devredildi' | 'Kapali'

export type Donem = {
  id: string
  yil: number
  ad: string
  baslangicTarihi: string
  bitisTarihi: string
  durum: DonemDurum
  aktif: boolean
  kaynakDonemId?: string | null
  devirTarihi?: string | null
}

export type DonemOlusturInput = {
  yil: number
  ad: string
  baslangicTarihi: string
  bitisTarihi: string
  aktif?: boolean
}

export type DonemGuncelleInput = {
  ad?: string
  baslangicTarihi?: string
  bitisTarihi?: string
}

export type DevirOnizle = {
  kaynak: { id: string; yil: number; durum: DonemDurum }
  hedef: { id: string; yil: number; durum: DonemDurum }
  zatenDevredildi: boolean
  acilisBakiyeleri: {
    cari: { adet: number; netToplam: number }
    kasa: { adet: number; toplam: number }
    banka: { adet: number; toplam: number }
    stok: { adet: number; deger: number }
  }
  tasinacak: { cek: number; siparis: number; irsaliye: number }
}

export type DevirSonuc = {
  basarili: boolean
  olusturulan: { cariHareket: number; stokHareket: number; kasaHareket: number; bankaHareket: number }
  tasinan: { cek: number; siparis: number; irsaliye: number }
}

export type DevirSecenek = {
  kaynakDonemId: string
  hedefDonemId: string
  acilisBakiyeleri?: boolean
  cekTasi?: boolean
  belgeTasi?: boolean
}

const unwrap = <T,>(p: Promise<unknown>) => (p as Promise<{ data: T }>).then((r) => r.data)

export const donemApi = {
  liste: () => unwrap<Donem[]>(apiClient.get('/periods')),
  aktif: () => unwrap<Donem | null>(apiClient.get('/periods/active')),
  olustur: (dto: DonemOlusturInput) => unwrap<Donem>(apiClient.post('/periods', dto)),
  guncelle: (id: string, dto: DonemGuncelleInput) => unwrap<Donem>(apiClient.put(`/periods/${id}`, dto)),
  aktifYap: (id: string) => unwrap<Donem>(apiClient.post(`/periods/${id}/activate`, {})),
  kapat: (id: string) => unwrap<Donem>(apiClient.post(`/periods/${id}/close`, {})),
  yenidenAc: (id: string) => unwrap<Donem>(apiClient.post(`/periods/${id}/reopen`, {})),
  sil: (id: string) => unwrap<{ basarili: boolean }>(apiClient.delete(`/periods/${id}`)),

  devirOnizle: (kaynakDonemId: string, hedefDonemId: string) =>
    unwrap<DevirOnizle>(apiClient.post('/periods/devir/preview', { kaynakDonemId, hedefDonemId })),
  devirCalistir: (dto: DevirSecenek) => unwrap<DevirSonuc>(apiClient.post('/periods/devir', dto)),
  devirGeriAl: (hedefDonemId: string) => unwrap<{ basarili: boolean }>(apiClient.post('/periods/devir/undo', { hedefDonemId })),
}
